import { useColorScheme as useNativewindColorScheme } from 'nativewind';
import { useColorScheme as useReactNativeColorScheme } from 'react-native';
import { useEffect, useRef } from 'react';

export function useColorScheme() {
  const {
    colorScheme: cs,
    setColorScheme,
    toggleColorScheme,
  } = useNativewindColorScheme();

  const colorScheme = cs ?? 'light';
  const systemColorScheme = useReactNativeColorScheme();
  const prevSystemColorScheme = useRef<string | null | undefined>(null);

  useEffect(() => {
    // Only sync when system color scheme actually changes
    // Don't check against current nativewind colorScheme to avoid feedback loop
    if (
      systemColorScheme &&
      systemColorScheme !== prevSystemColorScheme.current
    ) {
      prevSystemColorScheme.current = systemColorScheme;
      setColorScheme(systemColorScheme);
    }
  }, [systemColorScheme, setColorScheme]);

  return {
    colorScheme: colorScheme,
    isDarkColorScheme: colorScheme === 'dark',
    setColorScheme,
    toggleColorScheme,
  };
}
